import {mainWeb} from '../../../config/net'

const activeCard = {
  url: `${mainWeb}/onlinemall/ajax/mobileonlinemall.ashx`,
  method: 'activecoupon'
}
export default {
  activeCard
}



// WEBPACK FOOTER //
// ./src/model/coupon/card-bind/resource-url.js